import { mockDataInstance } from '@/api/core';
const { default: Requestor } = require('@/api/Requestor');
class MockDataApi extends Requestor {
    // eslint-disable-next-line no-useless-constructor
    constructor(args) {
        super(args);
    }
    /**
     * 라이더 상세조회 리스트 임의 api
     */
    getDetailsPerWorkerList(params = {}) {
        return this.get({
            url: '/workers',
            params,
        });
    }
    /**
     * 사용자관리 리스트 임의 api
     */
    getMockDataUserList(params = {}) {
        return this.get({
            url: '/users',
            params,
        });
    }
}
export default new MockDataApi(mockDataInstance);
